import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const CallingScriptModal = ({
  showCallingScript,
  handleClose,
  customer_name,
  product_name,
  customer_mobile_number,
  notice_date,
  email_id,
  loan_account_no,
  pos,
  pre_approved_settlement_amount,
  collection_manager_name,
  collection_manager_mobile_number,
  client_name,
 
}) => {
  const [language, setLanguage] = useState('english');

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    else if (hour < 18) return "Good Afternoon";
    else return "Good Evening";
  };

  return (
    <Modal show={showCallingScript} onHide={handleClose} centered dialogClassName="custom-modal">
      <Modal.Header closeButton>
        <Modal.Title>Notice Information</Modal.Title>
        
      </Modal.Header>

      <Modal.Body>
        {/* <div className="d-flex justify-content-end mb-3">
        
        </div> */}

        {language === 'english' ? (
          <div>
            <p className='mt-3'>Hi, I am calling from <strong>K S Legal</strong>. Am I speaking to <strong>{customer_name}</strong>? You have defaulted on the <strong>{product_name}</strong> account ending <strong>{loan_account_no}</strong>, issued by <strong>{client_name}</strong>, is that correct?</p>

            <p>We have been assigned this case by <strong>{client_name}</strong> to start legal proceedings.</p>

            <p>Since you are a valued customer, we have sent a notice to your registered email id being <strong>{email_id}</strong> on <strong>{notice_date}</strong>.</p>

            <p>Please consider this as a final opportunity before starting any legal action against you. Your total outstanding is <strong>Rs. {pos}</strong>. Please get in touch with <strong>{collection_manager_name}</strong> on <strong>{collection_manager_mobile_number}</strong> to clear your outstanding.</p>

            <p>Also, please note, in case of continuous non-payment we will be forced to initiate legal action which includes Civil Case, Criminal case or Police complaint as per the instruction of <strong>{client_name}</strong>.</p>
          </div>
        ) : (
          <div>
            <p className='mt-3'>Hi, main K S Legal se bol raha hoon. Kya main <strong>{customer_name}</strong> se baat kar raha hoon?</p>
            <p>Aapka <strong>{client_name}</strong> ka <strong>{product_name}</strong> account <strong>{loan_account_no}</strong> pe end hota hai. System ke according, aapka payment default me gaya hai — kya ye sahi hai?</p>
            <p><strong>{client_name}</strong> ne ye case hume assign kiya hai legal proceedings start karne ke liye.
Aap ek valued customer hain, isliye legal action start karne se pehle hi humne ek notice aapke registered email id <strong>{email_id}</strong> par <strong>{notice_date}</strong> ko bheja tha.</p>
            <p>Ab ye aapka final opportunity hai kisi bhi legal action ke pehle.
Aapka total outstanding amount Rs. <strong>{pos}</strong> hai. Please <strong>{collection_manager_name}</strong> se <strong>{collection_manager_mobile_number}</strong> par contact karke apna payment clear kar dein.</p>
            <p>Agar aap immediately payment clear nahi karte ho, to hume legal action lena padega — jisme Civil Case, Criminal Case, ya Police Complaint file ki ja sakti hai <strong>{client_name}</strong> ke behalf par.</p>
          </div>
        )}
      </Modal.Body>

     <Modal.Footer className="d-flex justify-content-between w-100">
  <Button
    variant="primary"
    size="md"
    onClick={() => setLanguage(language === 'english' ? 'hindi' : 'english')}
  >
    {language === 'english' ? 'Switch to Hindi' : 'Switch to English'}
  </Button>

  <Button variant="secondary" onClick={handleClose}>
    Close
  </Button>
</Modal.Footer>

    </Modal>
  );
};

export default CallingScriptModal;
